import { render, staticRenderFns } from "./companyMobile.vue?vue&type=template&id=b643f7ae&scoped=true&"
import script from "./companyMobile.vue?vue&type=script&lang=js&"
export * from "./companyMobile.vue?vue&type=script&lang=js&"
import style0 from "./companyMobile.vue?vue&type=style&index=0&id=b643f7ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b643f7ae",
  null
  
)

export default component.exports